import React from 'react';
import PropTypes from 'prop-types';
import { FormInput, Button } from '@getgrover/ui';

import {
    LayoutComponent_Text as LegacyText,
    LayoutComponent_LocalLoader as LocalLoader,
} from 'ggApp/modules/layout';
import { Translator } from 'ggApp/modules/translator';
import { CREDIT_CARD_MASK_SYMBOL } from 'ggApp/modules/payment/constants';

import PaymentIframeInput from 'ggApp/shared/common/Payment/PaymentGatewayList/CreditCard/NewFlow/PaymentIframeInput';
import PaymentMessage from 'ggApp/shared/common/Payment/PaymentGatewayList/PaymentMessage';
import getTkForPaymentLibraryError from 'ggApp/shared/common/Payment/PaymentGatewayList/CreditCard/NewFlow/paymentLibraryError';

import {
    StyledForm,
    SplitBox,
    SplitBoxItem,
    GlobalDarkThemeFormStyles,
    iframeInputStyleObject,
} from './styles';

const CreditCardFormUi = ({
    isFormLoading,
    isFormValid,
    paymentLibraryLoadFailed,
    handleSubmit,
    is3dsRequired,
    translationFunction,
    formErrorState,
    formState,
    paymentLibrary,
    handleIframeInputBlur,
    onInput,
    handleInputBlur,
    isFormSubmitting,
    tokenizationErrors,
    paymentMethodCreationFailed,
}) => {
    return (
        <React.Fragment>
            <LocalLoader active={isFormLoading}>
                {paymentLibraryLoadFailed && (
                    <PaymentMessage>
                        <LegacyText error>
                            <Translator tk="CREDIT_CARD_FORM_ERROR_FAILED_TO_LOAD_LIBRARY" />
                        </LegacyText>
                    </PaymentMessage>
                )}
            </LocalLoader>
            {!paymentLibraryLoadFailed && (
                <StyledForm isVisuallyHidden={isFormLoading} onSubmit={handleSubmit}>
                    <GlobalDarkThemeFormStyles />
                    {!is3dsRequired && (
                        <React.Fragment>
                            <SplitBox>
                                <SplitBoxItem>
                                    <PaymentIframeInput
                                        iframeInputStyleObject={iframeInputStyleObject}
                                        label={translationFunction('FORM_LABEL_CC_NUMBER')}
                                        error={
                                            formErrorState.cardNumber &&
                                            translationFunction(formErrorState.cardNumber)
                                        }
                                        isEmpty={!formState.cardData.numberLength > 0}
                                        fieldType="number"
                                        iframeTargetId="myRandomId-cardNumber"
                                        paymentLibrary={paymentLibrary}
                                        onBlur={() => handleIframeInputBlur('cardNumber')}
                                    />
                                </SplitBoxItem>
                            </SplitBox>
                            <div>
                                <FormInput
                                    label={translationFunction('FORM_LABEL_CC_HOLDER_NAME')}
                                    error={
                                        formErrorState.cardholderName &&
                                        translationFunction(formErrorState.cardholderName)
                                    }
                                    input={{
                                        name: 'cardholderName',
                                        type: 'text',
                                        value: formState.cardholderName,
                                        onChange: onInput,
                                        onBlur: handleInputBlur,
                                    }}
                                />
                            </div>
                            <SplitBox>
                                <SplitBoxItem>
                                    <FormInput
                                        label={translationFunction('FORM_LABEL_CC_VALID_THRU')}
                                        error={
                                            formErrorState.cardExpiration &&
                                            translationFunction(formErrorState.cardExpiration)
                                        }
                                        input={{
                                            name: 'cardExpiration',
                                            type: 'text',
                                            value: formState.cardExpiration,
                                            onChange: onInput,
                                            onBlur: handleInputBlur,
                                            mask: '99 / 99',
                                            maskChar: CREDIT_CARD_MASK_SYMBOL,
                                        }}
                                    />
                                </SplitBoxItem>
                                <SplitBoxItem>
                                    <PaymentIframeInput
                                        iframeInputStyleObject={iframeInputStyleObject}
                                        label={translationFunction('FORM_LABEL_CC_CVC')}
                                        error={
                                            formErrorState.cardCVV &&
                                            translationFunction(formErrorState.cardCVV)
                                        }
                                        fieldType="cvv"
                                        isEmpty={!formState.cardData.cvvLength > 0}
                                        iframeTargetId="myRandomId-cvv"
                                        onBlur={() => handleIframeInputBlur('cardCVV')}
                                        paymentLibrary={paymentLibrary}
                                    />
                                </SplitBoxItem>
                            </SplitBox>
                        </React.Fragment>
                    )}

                    {is3dsRequired && (
                        <SplitBox>
                            <SplitBoxItem>
                                <LegacyText>
                                    <Translator tk="CREDIT_CARD_FORM_3DS_REQUIRED" />
                                </LegacyText>
                            </SplitBoxItem>
                        </SplitBox>
                    )}

                    <Button
                        type="submit"
                        primary
                        fullWidth
                        loading={isFormSubmitting}
                        disabled={!isFormValid(formState)}
                    >
                        <Translator tk="CREDIT_CARD_FORM_SUBMIT_BUTTON_LABEL" />
                    </Button>
                </StyledForm>
            )}
            {tokenizationErrors &&
                tokenizationErrors.map((error) => (
                    <LegacyText error key={error}>
                        {getTkForPaymentLibraryError(error)}
                    </LegacyText>
                ))}
            {paymentMethodCreationFailed && (
                <LegacyText error>
                    <Translator tk="CREDIT_CARD_FORM_FAILED_TO_SUBMIT" />
                </LegacyText>
            )}
        </React.Fragment>
    );
};

CreditCardFormUi.propTypes = {
    gateway: PropTypes.shape({
        meta: PropTypes.shape({
            public_api_key: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

export default CreditCardFormUi;
